
// AJAX call to save project options to session

import { initializePriceCalculation } from './custom-javascript.js';

jQuery(function ($) {
    $("#cart-order-options-form").on("submit", function (e) {
        e.preventDefault();

        let formData = {};
        $("#cart-order-options-form :input:visible").each(function () {
            let id = this.id.replace("field_", "");
            formData[id] = $(this).val();
        });

        if (formData.drawer_slide !== "Movento") {
            formData.drawer_box_colour = "undefined";
        }

        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "set_session_project_attributes",
                nonce: project_atts.nonce,
                ...formData
            },
            success: (response) => {

                const update_cart = jQuery("[name=\"update_cart\"]");
                const is_cart_page = jQuery("body").hasClass("woocommerce-cart");
                if (!is_cart_page) {
                    try {
                        initializePriceCalculation();
                    } catch (error) {
                        console.log("Error: " + error);
                    }
                }


                // enable button
                update_cart.prop("disabled", false);
                update_cart.trigger("click");
            },
            error: (xhr, status, error) => {
                console.log("Error: " + error);
            },
        });
    });
});


jQuery(function ($) {
    $("#product-order-options-form").on("submit", function (e) {
        e.preventDefault();

        let formData = {};
        $("#cart-order-options-form :input:visible").each(function () {
            let id = this.id.replace("field_", "");
            formData[id] = $(this).val();
        });

        if (formData.drawer_slide !== "Movento") {
            formData.drawer_box_colour = "undefined";
        }

        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "set_session_project_attributes",
                nonce: project_atts.nonce,
                ...formData
            },
            success: (response) => {

                //close modal
                // try initializePriceCalculation();
                try {
                    initializePriceCalculation();
                } catch (error) {
                    console.log("Error: " + error);
                }

                $('#projectOptionsModal').modal('hide');



            },
            error: (xhr, status, error) => {
                console.log("Error: " + error);
            },
        });
    });
});